<p class="title">
    <img class="icon-title" src="assets/images/edit.svg" alt="Image" />
    {{'sub-grupo-edit.texts.edit_novo_subgrupo' | translate}}
</p>
<div class="container">
    <div id="mainDiv" class="main-div form-div">
        <div id="mainDiv" class="form-container">
            <div class="form-column">
                <div class="form-item form-item-25">
                    <label class="pb-2">{{'sub-grupo-edit.labels.grupos' | translate}}</label>
                    <p-multiSelect id="selecionarGrupo" [options]="grupos"
                        [(ngModel)]="form.grupo_id" optionLabel="nome"
                        placeholder="{{'sub-grupo-edit.placeholders.selecione' | translate}}"
                        optionValue="id" [filter]="true" filterBy="nome"
                        [showToggleAll]="true" display="chip"></p-multiSelect>
                </div>
                <div class="form-item form-item-25">
                    <label class="pb-2">{{'sub-grupo-edit.labels.nome' | translate}}</label>
                    <input type="text" pInputText
                        placeholder="{{'sub-grupo-edit.placeholders.nome_do_estado' | translate}}"
                        [(ngModel)]="form.nome" />
                </div>
            </div>

            <div class="form-column">
                <div class="form-item form-item-100">
                    <button pButton label="{{'sub-grupo-edit.botoes.salvar' | translate}}" class="w-8rem"
                        (click)="submit()"></button>
                </div>
            </div>
        </div>
    </div>
</div>